import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-11-01 16:41:15
 * @LastEditTime: 2022-01-09 15:26:00
 * @LastEditors: wangshengqiang
 * @Description: 银行选择组件
 */
import React, { useEffect, useState } from 'react'; // import { Toast } from 'zarm';
// import { isPreviewMode } from '@/utils/tool';
// import { getEnumList } from '@/services/dict.js';

import RowSelect from '../RowSelect';
export default function Banks(props) {
  // const { attrs = {}, ...rest } = props;
  // const { dataSource = [] } = attrs;
  // const [ds, setDs] = useState(dataSource);
  // useEffect(() => {
  //   if (ds.length !== 0 && !isPreviewMode()) {
  //     getEnumList('bank').then((res) => {
  //       const { success, message, result } = res;
  //       if (success) {
  //         setDs(result);
  //       } else {
  //         Toast.show(message);
  //       }
  //     });
  //   }
  // }, []);
  const _props = _objectSpread({
    // dataSource: ds,
    valueMember: 'code',
    textMember: 'name'
  }, props);

  return /*#__PURE__*/React.createElement(RowSelect, _props);
}